import type { AnchorHTMLAttributes, ReactNode, Ref } from 'react'
import styles from './shell.module.css'

export type AdminNavItemProps = AnchorHTMLAttributes<HTMLAnchorElement> & {
  ref?: Ref<HTMLAnchorElement>
  icon: ReactNode
}

/** Пункт меню админки по макету: светлый, активный — чёрная плашка. Оборачивается `createLink` роутера. */
export function AdminNavItem({ icon, children, className: _ignored, ...rest }: AdminNavItemProps) {
  return (
    <a className={styles.nav} {...rest}>
      <span className={styles.icon}>{icon}</span>
      {children}
    </a>
  )
}
